export default {
    nav: {
        index: "Settings",
        user: "Account",
        address: "Address",
        info: "Basic",
        profile: "Profile",
        connect: "Connect",
    },
    address: {
        add: "Add new address",
        edit: "Edit Address",
        name: "Name",
        namePlaceholder: "Please enter a contact person",
        phone: "Phone Number",
        phonePlaceholder: "Please enter your contact number",
        addr: "Address",
        addrPlaceholder: "Please enter the detail address",
        regionPlaceholder: "Please enter the Province/City/Region",
        tag: "Tag",
        school: "School",
        home: "Home",
        company: "Company",
        custom: "Custom",
        isDefault: "Default Address",
        defaultTag: "Default",
        setDefault: "Set as Default",
        cancelDefault: "Cancel default",
        region: "Province/City/Region",
    },
    info: {
        avatar: "Avatar",
        nickname: "Nickname",
        email: "Email",
        phone: "Phone",
        locale: "Language",
        nicknameRequired: "Please enter a nickname",
        nicknameExist: "Nickname already exists",
        country: "Country",
        countryPlaceholder: "Please select your country",
        countryRequired: "Please select your country",
    },
    profile: {
        birth: "Birthday",
        bio: "Bio",
        birthPlaceholder: "Please select your birthday",
    },
};
